import { Injectable } from '@angular/core'
import { HttpBackend, HttpClient } from '@angular/common/http'
import { AngularFireAnalytics } from '@angular/fire/compat/analytics'
import { LocalStorageService } from '../../providers/local-storage/local-storage.service'

@Injectable({
  providedIn: 'root'
})
export class AnalyticService {
  private loggingHttpClient: HttpClient

  constructor(
    httpBackend: HttpBackend,
    private analytics: AngularFireAnalytics,
    private localStrorageService: LocalStorageService
  ) {
    this.loggingHttpClient = new HttpClient(httpBackend)
  }

  userLocal: any

  /**
   * Ghi event Firebase Analytics
   */
  async logEvent(flowName: string, data?: Record<string, any>): Promise<void> {
    try {
      await this.analytics.logEvent(flowName, data)
    } catch (err) {
      console.error('[AnalyticService] logEvent error:', err)
    }
  }

  /**
   * Ghi log lỗi
   */
  async logError(
    flowName: string,
    error: any,
    extra?: Record<string, any>
  ): Promise<void> {
    this.userLocal = this.localStrorageService.get('userProfile')

    console.log(this.userLocal)

    const errorData = {
      ...extra,
      message: error?.message || error?.toString(),
      stack: error?.stack || '',
      log_time: new Date().toISOString(),
      username: this.userLocal.id
    }

    await this.logEvent(`${flowName}`, errorData)
    await this.logToServer(flowName, errorData)
  }

  /**
   * Gửi log về server (nếu có)
   */
  async logToServer(flow: string, payload: any): Promise<void> {
    try {
      const body = { flow, ...payload }
      await this.loggingHttpClient.post('/api/log', body).toPromise()
    } catch (err) {
      console.warn('[AnalyticService] logToServer failed:', err)
    }
  }

  /**
   * Bắt đầu một flow tracking
   */
  startFlow(flowName: string): FlowTracker {
    return new FlowTracker(flowName, this)
  }
}

/**
 * Class hỗ trợ theo dõi một flow cụ thể
 */
export class FlowTracker {
  private flowName: string
  private startTime: Date
  private service: AnalyticService

  constructor(flowName: string, service: AnalyticService) {
    this.flowName = flowName
    this.service = service
    this.startTime = new Date()
  }

  complete(userId: string): void {
    const duration = (new Date().getTime() - this.startTime.getTime()) / 1000

    this.service.logEvent(this.flowName, {
      log_time: new Date().toISOString(),
      duration_seconds: duration,
      userId: userId
    })

    console.log('Complete')
  }

  fail(error: any): void {
    const duration = (new Date().getTime() - this.startTime.getTime()) / 1000

    this.service.logError(this.flowName, error, {
      log_time: new Date().toISOString(),
      duration_seconds: duration,
      message: error?.message || 'Không xác định',
      stack: error?.stack
    })
  }
}
